import numeral from 'numeral';
import CircularProgressCard from '../../lib/cards/CircularProgressCard';

export default class SalesRevenueGoal extends CircularProgressCard {
  constructor(props) {
    super(props)
    this.state.type='currency';
  }
  getMessage(difference) {
    return `You need to make ${numeral(difference).format('$0,0.00')} more to reach your goal`;
  }
  getInitialValue() {
    return numeral(super.getInitialValue()).format('$0,0.00');
  }
  getCurrentGoal() {
    let { goal } = this.state;
    if (goal !== undefined && goal !== null) {
        return numeral(this.state.goal).format('$0,0');
    } else {
      return this.state.goal || '';
    }
  }
  handleCancel() {
    this.setState({
      goal: this.props.goal
    }, () => {
      this.toggleDialog();
    })
  }
  handleChangeGoal(event) {
    this.setState({
      goal: numeral(event.target.value).value()
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/series/goalCards/SalesRevenueGoal.js